import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["animation", "onAnimationLoad"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React, { useEffect, useId, useState } from 'react';
import { Ratio } from 'react-bootstrap';
import { create } from '@lottiefiles/lottie-interactivity';
import { Image } from '../image/image';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PlayMode;

(function (PlayMode) {
  PlayMode["Scroll"] = "scroll";
  PlayMode["Auto"] = "auto";
  PlayMode["Manual"] = "manual";
})(PlayMode || (PlayMode = {}));

export var ActionType;

(function (ActionType) {
  ActionType["Seek"] = "seek";
  ActionType["Stop"] = "stop";
  ActionType["Play"] = "play";
  ActionType["Hold"] = "hold";
  ActionType["PauseHold"] = "pauseHold";
  ActionType["PlayOnce"] = "playOnce";
  ActionType["Loop"] = "loop";
  ActionType["Click"] = "click";
  ActionType["Hover"] = "hover";
  ActionType["Toggle"] = "toggle";
})(ActionType || (ActionType = {}));

var TRANSPARENT_PLACEHOLDER_BG = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
var LazyPlayer = /*#__PURE__*/React.lazy(function () {
  return import('@lottiefiles/react-lottie-player').then(function (module) {
    return {
      "default": module.Player
    };
  });
});
export var LottieAnimation = function LottieAnimation(_ref) {
  var _ref$animation = _ref.animation,
      src = _ref$animation.src,
      _ref$animation$placeh = _ref$animation.placeholderImage,
      placeholderImage = _ref$animation$placeh === void 0 ? {
    src: TRANSPARENT_PLACEHOLDER_BG,
    width: 1600,
    height: 1200,
    priority: true,
    alt: 'Loading animation placeholder'
  } : _ref$animation$placeh,
      _ref$animation$loop = _ref$animation.loop,
      loop = _ref$animation$loop === void 0 ? true : _ref$animation$loop,
      _ref$animation$keepLa = _ref$animation.keepLastFrame,
      keepLastFrame = _ref$animation$keepLa === void 0 ? true : _ref$animation$keepLa,
      _ref$animation$playMo = _ref$animation.playMode,
      playMode = _ref$animation$playMo === void 0 ? PlayMode.Scroll : _ref$animation$playMo,
      _ref$animation$action = _ref$animation.actionType,
      actionType = _ref$animation$action === void 0 ? ActionType.Play : _ref$animation$action,
      _ref$animation$visibi = _ref$animation.visibility,
      visibility = _ref$animation$visibi === void 0 ? [0.3, 0.8] : _ref$animation$visibi,
      containerId = _ref$animation.containerId,
      onAnimationLoad = _ref.onAnimationLoad,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(),
      lottie = _useState[0],
      setLottie = _useState[1];

  useEffect(function () {
    if (!lottie) {
      return;
    }

    var configureToPlayOnScroll = function configureToPlayOnScroll() {
      create({
        mode: 'scroll',
        player: lottie,
        container: containerId,
        actions: [{
          visibility: visibility,
          type: actionType
        }]
      });
    };

    if (playMode === PlayMode.Scroll) {
      configureToPlayOnScroll();
    }

    onAnimationLoad && onAnimationLoad(lottie);
  }, [lottie]);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
    role: "presentation",
    className: "lottie-animation position-relative",
    children: [/*#__PURE__*/_jsx(Ratio, {
      aspectRatio: "16x9",
      className: classNames('lottie-animation-placeholder-image opacity-0', {
        'position-absolute': lottie
      }),
      role: "presentation",
      children: /*#__PURE__*/_jsx(Image, {
        priority: true,
        src: placeholderImage === null || placeholderImage === void 0 ? void 0 : placeholderImage.src,
        alt: placeholderImage === null || placeholderImage === void 0 ? void 0 : placeholderImage.alt,
        width: placeholderImage === null || placeholderImage === void 0 ? void 0 : placeholderImage.width,
        height: placeholderImage === null || placeholderImage === void 0 ? void 0 : placeholderImage.height,
        "data-testid": "placeholder-image",
        role: "presentation",
        style: {
          objectFit: 'contain'
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('lottie-animation-player', {
        'animate-fade-in': lottie
      }),
      children: /*#__PURE__*/_jsx(React.Suspense, {
        fallback: /*#__PURE__*/_jsx(_Fragment, {}),
        children: /*#__PURE__*/_jsx(LazyPlayer, {
          id: useId(),
          lottieRef: function lottieRef(instance) {
            return setLottie(instance);
          },
          autoplay: playMode === PlayMode.Auto,
          loop: loop,
          keepLastFrame: keepLastFrame,
          src: src
        })
      })
    })]
  }));
};